import { sendRequest } from './api';
import { locale } from './config';
export const fetchIndustries = async () => {
  try {
    const data = await sendRequest(
      'GET',
      '/api/plm/product/category-groups',
      null,
      { locale }
    );
    return data;
  } catch (error) {
    console.error(error.message);
  }
};

export const fetchTypeSeries = async id => {
  try {
    const data = await sendRequest(
      'GET',
      `/api/plm/product/category-groups/${id}`,
      null,
      { locale }
    );
    return data;
  } catch (error) {
    console.error(error.message);
  }
};

export const fetchFilesList = async params => {
  try {
    const data = await sendRequest(
      'GET',
      '/api/plm/product/published-files',
      null,
      { ...params, locale }
    );
    return data;
  } catch (error) {
    console.error(error.message);
  }
};

export const fetchSearchRes = async params => {
  try {
    const data = await sendRequest(
      'GET',
      '/api/plm/website/product/published-files',
      null,
      { ...params, locale }
    );
    return data;
  } catch (error) {
    console.error(error.message);
  }
};

export const fetchFileDownload = async doc_id => {
  try {
    const data = await sendRequest(
      'GET',
      `/api/common/documents/${doc_id}`,
      null,
      { verbose: 100 }
    );
    return data;
  } catch (error) {
    console.error(error.message);
  }
};
